import { render } from "./HelpWindow.vue?vue&type=template&id=60c9a79a&scoped=true&ts=true"
import script from "./HelpWindow.vue?vue&type=script&lang=ts"
export * from "./HelpWindow.vue?vue&type=script&lang=ts"

import "./HelpWindow.vue?vue&type=style&index=0&id=60c9a79a&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c9a79a"]])

export default __exports__